const ELEMENT_SEALS = {
  Fuego: { abbr: 'FU', variant: 'element-fire', label: 'Elemento: Fuego' },
  Agua: { abbr: 'AG', variant: 'element-water', label: 'Elemento: Agua' },
  Viento: { abbr: 'VI', variant: 'element-wind', label: 'Elemento: Viento' },
  Rayo: { abbr: 'RA', variant: 'element-lightning', label: 'Elemento: Rayo' },
  Tierra: { abbr: 'TI', variant: 'element-earth', label: 'Elemento: Tierra' },
}

const normalizeElement = (value) => {
  const raw = String(value || '').trim()
  if (!raw) return ''
  const match = Object.keys(ELEMENT_SEALS).find((k) => k.toLowerCase() === raw.toLowerCase())
  return match || raw
}

const toAbbr = (value, len = 2) => {
  const text = String(value || '').trim()
  if (!text) return ''
  return text.slice(0, len).toUpperCase()
}

/**
 * Sellos temporales bajo el avatar: clan, provincia (shogunato) y elemento.
 */
export const buildCharacterSeals = (char = {}) => {
  const academyMode = Boolean(char?.academyMode)
  const clan = String(char?.clan || '').trim()
  const province = String(char?.province || char?.shogunato || '').trim()
  const elementRaw = normalizeElement(char?.element)
  // Estudiantes: sin sello de elemento (aún latente). Shinobi: default visual Fuego si falta.
  const elementName = elementRaw || (academyMode ? '' : 'Fuego')
  const elementSeal = elementName
    ? ELEMENT_SEALS[elementName] || {
        abbr: toAbbr(elementName, 2),
        variant: 'element-generic',
        label: `Elemento: ${elementName}`,
      }
    : null

  const seals = []

  if (clan) {
    seals.push({
      key: 'clan',
      text: toAbbr(clan, 2),
      title: `Clan ${clan}`,
      variant: 'clan',
    })
  }

  if (province) {
    seals.push({
      key: 'province',
      text: toAbbr(province, 2),
      title: `Provincia: ${province}`,
      variant: 'province',
    })
  }

  if (elementSeal) {
    seals.push({
      key: 'element',
      text: elementSeal.abbr,
      title: elementSeal.label,
      variant: elementSeal.variant,
    })
  }

  return seals
}
